var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label"},[_vm._v(" * "+_vm._s(_vm.$t('allg_descr_pflichtfeld'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }